// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Kb1A","title":"ClientReferral_title__1Nju1","itemText":"ClientReferral_itemText__1JKRl"};